<app-coupon-slider-1
[coupon]="coupon"
[productCoupon]="productCoupon"
[typeCode]="typeCode"
(couponSettingsChanged)="changeCouponSettings()"
[isProductCoupon]="isProductCoupon"
>
</app-coupon-slider-1>

<app-coupon-slider-2
[coupon]="coupon"
[typeCode]="typeCode"
*ngIf="!isProductCoupon"
(couponSettingsChanged)="changeCouponSettings()"
>
</app-coupon-slider-2>

<app-coupon-slider-3
[coupon]="coupon"
[typeCode]="typeCode"
*ngIf="!isProductCoupon"
(couponSettingsChanged)="changeCouponSettings()"
>
</app-coupon-slider-3>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupons-sliders.component.html